/**
 * Colour dots of the collection cards (blocks/nadine-card-swatches.liquid), like Revolve: hovering a dot previews
 * that colour's photo on the card, leaving the dots brings back the selected colour; a click (or a tap) selects the
 * colour: photos (photo + hover photo) and the card's links. The cover colour's dot brings the cover back.
 * Uses the same data-orig-* attributes as the colour filter (snippets/nadine-filters.liquid), so the two do not
 * undo each other's originals.
 */
if (!window.nadineCardSwatches) {
  window.nadineCardSwatches = true;

  const cardOf = (swatch) => swatch.closest('li') || swatch.closest('product-card');
  const swatchOf = (event) => event.target instanceof Element && event.target.closest('.nadine-card-swatch');

  /** Show a colour's photos on the card (the cover's dot: the original cover) */
  const showPhotos = (card, swatch) => {
    const cover = !swatch || swatch.hasAttribute('data-cover');
    const urls = cover ? [] : (swatch.dataset.photos || '').split(',').filter(Boolean);
    const imgs = Array.from(card.querySelectorAll('.nadine-card-cover > img'));
    imgs.forEach((img, i) => {
      img.dataset.origSrc ??= img.getAttribute('src');
      img.dataset.origSrcset ??= img.getAttribute('srcset') || '';
      if (urls[i]) {
        if (img.getAttribute('src') === urls[i]) return;
        img.removeAttribute('srcset');
        img.src = urls[i];
      } else if (img.getAttribute('src') !== img.dataset.origSrc) {
        img.src = img.dataset.origSrc;
        if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
      }
    });
    // one photo only: no hover, rather than another colour's photo
    imgs[0]?.parentElement.classList.toggle('nadine-card-cover--no-hover', !cover && urls.length < 2);
  };

  // Hover preview (mouse only: on touch the tap selects)
  document.addEventListener('pointerover', (event) => {
    const swatch = event.pointerType === 'mouse' && swatchOf(event);
    const card = swatch && cardOf(swatch);
    if (card) showPhotos(card, swatch);
  });

  document.addEventListener('pointerout', (event) => {
    const group = event.pointerType === 'mouse' && event.target instanceof Element && event.target.closest('.nadine-card-swatches');
    if (!group || group.contains(/** @type {Node} */ (event.relatedTarget))) return;
    const card = cardOf(group);
    if (!card) return;
    const selected = group.querySelector('.nadine-card-swatch[aria-pressed="true"]');
    // nothing selected yet (no cover colour): back to the cover
    showPhotos(card, selected);
  });

  document.addEventListener(
    'click',
    (event) => {
      const swatch = swatchOf(event);
      if (!swatch) return;
      // the card navigates on any click inside it: a dot only changes the colour
      event.preventDefault();
      event.stopPropagation();

      const card = cardOf(swatch);
      if (!card) return;
      card.querySelectorAll('.nadine-card-swatch').forEach((s) => s.setAttribute('aria-pressed', String(s === swatch)));
      showPhotos(card, swatch);
      card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
        a.dataset.origHref ??= a.getAttribute('href');
        a.href = `${a.dataset.origHref.split('?')[0]}?variant=${swatch.dataset.variant}`;
      });

      const link = card.querySelector('a[href*="/products/"]');
      window.posthog?.capture?.('card_colour_selected', {
        colour: swatch.getAttribute('aria-label'),
        card_product: link?.dataset.origHref?.match(/\/products\/([^/?#]+)/)?.[1] ?? null,
      });
    },
    true
  );
}
